import React, { useEffect, useRef, useState } from "react";

export default function Contact() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const contactInfo = [
    {
      icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
      ),
      title: "Alamat",
      content: "Jl. Wirasaba No. 100, Kel. Adiarsa Barat, Kec. Karawang Barat, Karawang, Jawa Barat",
    },
    {
      icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
      ),
      title: "Telepon",
      content: "0877-8250-0285",
      link: "tel:087782500285",
    },
    {
      icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
      ),
      title: "Email",
      content: "ade.biohsa@gmail.com",
      link: "mailto:ade.biohsa@gmail.com",
    },
    {
      icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
      ),
      title: "PIC",
      content: "ADE PRIHARTANTO",
    },
  ];

  // Data dua lokasi maps
  const locations = [
    {
      label: "Office / Kantor",
      embedSrc:
          "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.123456789!2d107.298!3d-6.321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwMTknMTUuNiJTIDEwN8KwMTcnNTIuOCJF!5e0!3m2!1sen!2sid!4v1234567890",
      mapsUrl:
          "https://www.google.com/maps/search/?api=1&query=Jl.+Wirasaba+No.+100+Karawang+Barat",
      delay: "0.6s",
    },
    {
      label: "Garage / Garasi",
      embedSrc:
          "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.8!2d107.3799636!3d-6.3739019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6975b303f7acdf%3A0xa4d16cc8e56d9f51!2sPT+Berkat+Mandiri+Expedisi+-+GARASI!5e0!3m2!1sen!2sid!4v1234567891",
      mapsUrl:
          "https://www.google.com/maps/place/PT+Berkat+Mandiri+Expedisi+-+GARASI/@-6.3739019,107.3799636,17z",
      delay: "0.8s",
    },
  ];

  return (
      <section
          id="contact"
          ref={sectionRef}
          className="py-32 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden"
      >
        {/* Background blobs */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-6 lg:px-12 relative z-10">

          {/* Header */}
          <div className="text-center mb-20">
            <h2
                className={`text-5xl pb-4 lg:text-6xl font-bold text-gradient mb-6 transition-all duration-1000 ${
                    isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
                }`}
            >
              Hubungi Kami
            </h2>
            <p
                className={`text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 ${
                    isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
                }`}
                style={{ transitionDelay: "0.1s" }}
            >
              Siap melayani kebutuhan pengiriman Anda
            </p>
          </div>

          {/* Contact Info + Maps Grid */}
          <div className="grid lg:grid-cols-2 gap-12">

            {/* Kiri: Contact Info Cards */}
            <div className="space-y-8">
              {contactInfo.map((info, index) => (
                  <div
                      key={index}
                      className={`glass-dark rounded-3xl p-8 shadow-xl card-premium border border-primary/10 transition-all duration-1000 ${
                          isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-20"
                      }`}
                      style={{ transitionDelay: `${0.2 + index * 0.1}s` }}
                  >
                    <div className="flex items-start space-x-6">
                      <div className="w-16 h-16 rounded-2xl gradient-primary flex items-center justify-center text-white flex-shrink-0 glow">
                        {info.icon}
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-primary mb-2">{info.title}</h3>
                        {info.link ? (
                            <a
                                href={info.link}
                                className="text-gray-700 hover:text-primary transition-colors duration-300 text-lg"
                            >
                              {info.content}
                            </a>
                        ) : (
                            <p className="text-gray-700 text-lg">{info.content}</p>
                        )}
                      </div>
                    </div>
                  </div>
              ))}
            </div>

            {/* Kanan: Dua Maps (Office & Garage) */}
            <div className="flex flex-col gap-8">
              {locations.map((loc, i) => (
                  <div
                      key={i}
                      className={`transition-all duration-1000 ${
                          isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"
                      }`}
                      style={{ transitionDelay: loc.delay }}
                  >
                    {/* Label */}
                    <div className="mb-3">
                  <span className="inline-block px-5 py-2 rounded-full gradient-primary text-white font-bold text-sm uppercase tracking-wider shadow-md">
                    {loc.label}
                  </span>
                    </div>

                    {/* Map iframe */}
                    <div className="glass-dark rounded-3xl shadow-2xl overflow-hidden border border-primary/10">
                      <iframe
                          src={loc.embedSrc}
                          width="100%"
                          height="280"
                          style={{ border: 0, display: "block" }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title={loc.label}
                      ></iframe>
                    </div>

                    {/* Tombol buka maps */}
                    <a
                        href={loc.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-4 block w-full px-10 py-4 text-center rounded-full gradient-primary text-white font-bold text-sm uppercase tracking-wider btn-premium shadow-xl transition-all duration-300 hover:scale-[1.02]"
                    >
                      Buka di Google Maps
                    </a>
                  </div>
              ))}
            </div>

          </div>
        </div>
      </section>
  );
}
